import { render, staticRenderFns } from "./PageEditorAddExistingContentOffcanvas.vue?vue&type=template&id=b139ab42&scoped=true"
import script from "./PageEditorAddExistingContentOffcanvas.vue?vue&type=script&lang=js"
export * from "./PageEditorAddExistingContentOffcanvas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b139ab42",
  null
  
)

export default component.exports